<template>
  <div class="flex flex-wrap w-full p-0 m-0">
    <div class="lg:w-5/12 lg:pr-2">
      <p>Votre réponse</p>
      <ul class="p-0 py-1 m-0 text-lg list-none">
        <li class="pt-1.5 flex flex-wrap">
          <div
            class="flex flex-wrap items-center flex-shrink-0 pr-1 answer-status"
          >
            <div
              class="flex items-center justify-center w-2 h-2 mx-0.5 text-black bg-white rounded answer-icon"
            >
              <CheckIcon class="w-1 h-1" v-if="validAnswer()" />
            </div>
          </div>
          <span class="flex-1">{{ answer.choices[0] }}</span>
        </li>
      </ul>
    </div>
    <div class="lg:border-l lg:w-7/12 lg:pl-2">
      <p>La bonne réponse</p>
      <div v-if="question.answer" v-html="question.answer"></div>
      <ul class="p-0 py-1 m-0 text-lg list-none">
        <li class="pt-1.5 flex flex-wrap" v-for="answer in question.answers">
          <div
            class="flex flex-wrap items-center flex-shrink-0 pr-1 answer-status"
          >
            <div
              class="flex items-center justify-center w-2 h-2 mx-0.5 rounded answer-icon text-black"
              :class="{
                'bg-green': validAnswer(),
                'bg-corail': !validAnswer(),
              }"
            >
              <CheckIcon class="w-1 h-1" v-if="validAnswer()" />
              <CloseIcon class="w-1 h-1" v-if="!validAnswer()" />
            </div>
          </div>
          <span class="flex-1" v-html="answer.title"></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import CheckIcon from "./icons/CheckIcon.vue";
import CloseIcon from "./icons/CloseIcon.vue";
import { useQuizStore } from "@/stores/quiz";
const quizStore = useQuizStore();

const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  answer: {
    // type: Object,
    required: true,
  },
});
const validAnswer = () => {
  console.log(quizStore.getQuestionScore(props.question, props.answer));
  return quizStore.getQuestionScore(props.question, props.answer);
};
</script>
